import {GET_VERSIONS_PATH, PATH, SERVER_URL, SUBMIT_CLIENT_FORM_PATH} from "../consts/consts";
import {SelectedView, VersionData} from "../types/types";

export const fetchTrees = async (selectedView: SelectedView, selectedVersion: string | null, maxRetries = 3, delay = 1000) => {
    let retries = 0;
    
    while (retries <= maxRetries) {
        try {
            let url = `${SERVER_URL}${PATH[selectedView]}/${selectedView}/${selectedVersion}`;
            if (selectedView === SelectedView.Questionnaires) {
                url = `${SERVER_URL}${PATH[selectedView]}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.status === 429) {
                retries++;
                if (retries <= maxRetries) {
                    const waitTime = delay * Math.pow(2, retries - 1);
                    await new Promise(resolve => setTimeout(resolve, waitTime));
                    continue;
                }
            }
            
            if (!response.ok) {
                throw new Error(`Error fetching ${selectedView} tree: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            if (retries >= maxRetries) {
                throw error;
            }
            retries++;
            await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, retries - 1)));
        }
    }
};


export const getVersions = async () => {
    try {
        const url = `${SERVER_URL}${GET_VERSIONS_PATH}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching versions`);
        }

        const data = await response.json();

        Object.keys(data).forEach(view => {
            data[view].sort((a: VersionData, b: VersionData) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
        });

        return data;
    } catch (error) {
        throw error;
    }
};

export const submitClientForm = async (formData: any, helsinkiFile: string | null) => {
    try {
        const formDataToSend = {...formData};

        if (formData.inclusions) {
            formDataToSend.inclusions = JSON.stringify(formData.inclusions);
        }
        if (formData.exclusions) {
            formDataToSend.exclusions = JSON.stringify(formData.exclusions);
        }

        if (helsinkiFile) {
            formDataToSend.helsinkiFile = helsinkiFile;
        }

        const response = await fetch(`${SERVER_URL}${SUBMIT_CLIENT_FORM_PATH}`, {
            method: 'POST',
            body: JSON.stringify(formDataToSend),
        });

        if (!response.ok) {
            throw new Error(`Error submitting form`);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};